import * as React from 'react';

function SvgLocation(props) {
  return (
    <svg viewBox="0 0 13 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.912.002c.288 0 .575 0 .863-.002.146.021.293.046.44.065a6.238 6.238 0 013.226 1.421 6.2 6.2 0 011.963 2.893c.277.854.403 1.728.268 2.628-.134.899-.446 1.74-.82 2.559a26.05 26.05 0 01-3.97 6.177c-.405.471-.825.936-1.39 1.232l-.198.001c-.173-.116-.363-.212-.515-.35a9.434 9.434 0 01-.849-.837c-1.818-2.107-3.33-4.41-4.377-7-.424-1.05-.67-2.13-.497-3.28.182-1.198.635-2.271 1.407-3.2A6.235 6.235 0 014.905.178C5.237.1 5.576.06 5.912.002zm4.694 6.37c.013-2.32-1.889-4.231-4.232-4.25-2.32-.017-4.232 1.883-4.254 4.228-.022 2.325 1.894 4.25 4.24 4.259 2.323.01 4.232-1.894 4.246-4.236z" />
    </svg>
  );
}

export default SvgLocation;
